var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWardrobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "wardrobe_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.532 75.484V8.602a4.087 4.087 0 014.08-4.086h36.775a4.086 4.086 0 014.08 4.086v66.882M40.004 4.516v46.082m-22.471.276h44.936M17.532 61.802h44.936M17.532 72.577h44.936M38.4 56.231h3.2m-3.2 10.962h3.2m4.363-32.965v3.2m-11.921-3.2v3.2",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTcuNTMxNyA3NS40ODQ0VjguNjAyMjdDMTcuNTMxNyA3LjUxOTQgMTcuOTYxNSA2LjQ4MDggMTguNzI2NyA1LjcxNDU3QzE5LjQ5MTkgNC45NDgzNCAyMC41Mjk5IDQuNTE3MTIgMjEuNjEyNyA0LjUxNTYySDU4LjM4NjlDNTkuNDY5OCA0LjUxNzEyIDYwLjUwNzggNC45NDgzNCA2MS4yNzI5IDUuNzE0NTdDNjIuMDM4MSA2LjQ4MDggNjIuNDY3OSA3LjUxOTQgNjIuNDY3OSA4LjYwMjI3Vjc1LjQ4NDRNNDAuMDAyNyA0LjUxNTYyVjUwLjU5NzZNMTcuNTMxNyA1MC44NzQySDYyLjQ2NzlNMTcuNTMxNyA2MS44MDJINjIuNDY3OU0xNy41MzE3IDcyLjU3NzRINjIuNDY3OU0zOC4zOTk2IDU2LjIzMDlINDEuNk0zOC4zOTk2IDY3LjE5MjZINDEuNk00NS45NjMyIDM0LjIyODVWMzcuNDI4OU0zNC4wNDIgMzQuMjI4NVYzNy40Mjg5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgWardrobe as ReactComponent };